module.exports = __webpack_public_path__ + "static/media/img-empty-no-recharge.d62aa93f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/portfolio/truebalance/images/img-empty-no-recharge.svg
// module id = 413
// module chunks = 0